<template>
  <div>
    <el-dialog :title="$t('message.editPic')" :visible.sync="dialogVisible" width="600px" center
      :close-on-click-modal="false">
      <div class="content">
        <div class="avatar">
          <img :src="pic">
        </div>

        <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
          :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :data="{
            save_path: 'tim/',
            new_name: $route.query.id ? 'A_s_' + $route.query.id : 'A_s_rand',
          }">
          <el-button type="primary">{{ $t('message.editPic') }}</el-button>

        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="updatePic">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      pic: localStorage.getItem("japanUserRoleInfo") ? JSON.parse(localStorage.getItem("japanUserRoleInfo")).pic : ''
    };
  },
  methods: {
    // 修改头像
    updatePic() {
      this.$api.roleApi.updatePic({ pic: this.pic }).then(res => {
        this.$message.success(res.msg)
        let japanUserRoleInfo = JSON.parse(localStorage.getItem("japanUserRoleInfo"))
        japanUserRoleInfo.pic = this.pic
        localStorage.setItem("japanUserRoleInfo", JSON.stringify(japanUserRoleInfo))
        this.$parent.pic = this.pic
        this.$forceUpdate()
        this.dialogVisible = false
      })
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
      }
      return isJPG || isPNG || isSVG;
    },
    //上传成功
    handleAvatarSuccess(res) {
      this.pic = res.data
      this.$forceUpdate()
    },
  }
}
</script>
<style lang='scss' scoped>
.content {
  display: flex;

  .avatar {

    overflow: hidden;

    img {
      width: 300px;
      height: 300px;
      border-radius: 50%;
      margin-right: 30px;
    }
  }

  /deep/ .avatar-uploader {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>